<ng-template #content let-modal>
    <div class="modal-header session-modal-header">
        <h4 class="session-modal-title modal-title" *ngIf="secs > 0">Session Timeout</h4>
    </div>

    <div class="modal-body session-modal-body">
        <span class="session-modal-icon gp glyphish-AlarmClockOutline"></span>
        <p class="session-modal-text" *ngIf="secs > 0">Your Business Chemistry session will expire in {{timeLeftOver()}} minutes.</p>
    </div>

    <div class="modal-footer session-modal-footer">
        <input type="button" class="okBtn" (click)="refreshSession()" *ngIf="secs > 0" value='OK'/>
        <div *ngIf="secs == 0 && isOpened ? navigateToTimeout() : null"></div>
    </div>
</ng-template>
        

